export default __webpack_public_path__ + "static/media/ic_top-1.8c38ee6c.svg";